/**
 * Features whose required runtime config is unset at a pack or project —
 * every launch that includes them fails until a value is set.
 */

import { useQuery, type QueryClient } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import type { MissingRuntimeConfigItem } from '../schemas/admin.schemas';

const MISSING_KEY = ['runtime-config-missing'];

export type MissingRuntimeConfigCtx = { packId: string } | { projectId: string };

export function useMissingRuntimeConfig(ctx: MissingRuntimeConfigCtx) {
  const id = 'packId' in ctx ? ctx.packId : ctx.projectId;
  return useQuery<MissingRuntimeConfigItem[]>({
    queryKey: [...MISSING_KEY, 'packId' in ctx ? 'pack' : 'project', id],
    queryFn: () => adminApi.getMissingRuntimeConfig(ctx),
    enabled: id.length > 0,
  });
}

/**
 * Call after anything that can change the answer: a runtime-config write,
 * a pack item or project assignment change, or a pack (un)link.
 */
export function invalidateMissingRuntimeConfig(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: MISSING_KEY });
}
